//
// JS for all books page inputs
//

const ElevPrices = require("./ElevPrices");
const {$each, onClickOrEnter, preventBadQtyInput} = require("./ElevHelpers");
const {
	modifyCart,
	addItemsToCart,
	showAddToCartModal,
	getTotalQuantity,
} = require("./CartUtil");
const {openModalByName} = require("./ModalUtil");

// Returns an array of objects with these keys:
// - inputEl: the element where the quantity is input
// - skus: an array of sku items added by that quantity box
// - priceLineEl: the element where price previews are shown
function computeAllBooksInputList() {
	const allBooksInputList = [];

	$each(
		document,
		".ba11-p-bookall-set-row, .ba11-p-bookall-indiv-row",
		rowEl => {
			const setSkusAttr = rowEl.getAttribute("data-set-skus");
			const setSkus = setSkusAttr ? setSkusAttr.split(",") : null;
			const hash = rowEl.getAttribute("data-hash");

			$each(rowEl, ".ba11-p-bookall-item-qty", inputEl => {
				let skus;
				let priceLineEl = rowEl.querySelector(
					".ba11-p-bookall-item-price-line"
				);
				if (setSkus) {
					skus = setSkus;
				} else if (hash && inputEl.classList.contains("ba11--guide")) {
					skus = ["beast-" + hash.toLowerCase()];
					priceLineEl = rowEl.querySelector(
						".ba11-p-bookall-item-price-line.ba11--guide"
					);
				} else if (hash && inputEl.classList.contains("ba11--practice")) {
					skus = ["beast-" + hash.toLowerCase() + "-practice"];
					priceLineEl = rowEl.querySelector(
						".ba11-p-bookall-item-price-line.ba11--practice"
					);
				} else if (hash && hash.startsWith("puzzles")) {
					const grade = hash.slice(7);
					skus = ["beast-" + grade + "-puzzles"];
				} else if (hash && hash.endsWith("S")) {
					const level = hash.slice(0, 2).toLowerCase();
					skus = ["beast-" + level + "-science"];
				} else if (hash) {
					skus = ["beast-" + hash.toLowerCase()];
				}
				allBooksInputList.push({inputEl, skus, priceLineEl});
			});
		}
	);

	return allBooksInputList;
}

function setupAllBooksInputs(allBooksInputList) {
	function updateShownPrice(priceLineEl, total, totalNoDiscount) {
		let html = "$" + total.toFixed(2);
		if (totalNoDiscount > total) {
			html =
				`<div class="ba11-p-bookall-item-price-line-original">` +
				`$` +
				totalNoDiscount.toFixed(2) +
				`</div>` +
				html;
		}
		priceLineEl.innerHTML = html;
	}

	allBooksInputList.forEach(entry => {
		const {inputEl, skus, priceLineEl} = entry;
		preventBadQtyInput(inputEl, 2);
		inputEl.addEventListener("change", evt => {
			// We use parseFloat since fixQuantity will round and we can't detect and
			// fix fractional values if we round here.
			const quantityRaw = parseFloat(inputEl.value);
			const quantity = ElevPrices.fixQuantity(quantityRaw);
			if (quantity !== quantityRaw) {
				inputEl.value = quantity;
			}
			const cart = skus.map(sku => ({sku, quantity}));
			const total = ElevPrices.calculateTotalItemPrice(cart);
			const totalNoDiscount = ElevPrices.calculateTotalItemPrice(cart, {
				skipDiscounts: true,
			});
			updateShownPrice(priceLineEl, total, totalNoDiscount);
		});
	});
}

function resetAllBooksInputs() {
	computeAllBooksInputList().forEach(entry => {
		entry.inputEl.value = 0;
		entry.priceLineEl.innerHTML = "$0.00";
	});
}

function computeAllBooksAddedItems(allBooksInputList) {
	const quantitiesBySKU = {};

	allBooksInputList.forEach(entry => {
		const {inputEl, skus} = entry;
		const quantity = parseInt(inputEl.value);
		skus.forEach(sku => {
			quantitiesBySKU[sku] = (quantitiesBySKU[sku] || 0) + quantity;
		});
	});

	const addedItems = [];
	Object.keys(quantitiesBySKU).forEach(sku => {
		if (quantitiesBySKU[sku]) {
			addedItems.push({sku, quantity: quantitiesBySKU[sku], options: {}});
		}
	});

	return addedItems;
}

function setupAllBooks() {
	const allBooksInputList = computeAllBooksInputList();
	setupAllBooksInputs(allBooksInputList);

	$each(document, ".ba11-p-bookall-add-button", buttonEl => {
		const addToCartFunc = evt => {
			const itemsToAdd = computeAllBooksAddedItems(allBooksInputList);
			if (!itemsToAdd.length) {
				openModalByName("noItemsSelected", buttonEl);
				return;
			}
			modifyCart(c => {
				addItemsToCart(itemsToAdd, c);
			});
			resetAllBooksInputs();
			showAddToCartModal(getTotalQuantity(itemsToAdd), "book", buttonEl);
		};
		onClickOrEnter(buttonEl, addToCartFunc);
	});
}

module.exports = {
	setupAllBooks,
};
